import { downloadBlob, getBlob } from "../../common/actions/net";
import { getApi, postApi } from "../../common/actions/net.js";
import { getDeliveries, getNextDelivery } from "./delivery.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import { ContentTypes } from "../../common/net/httpClient";
import Logger from "../../common/util/Logger.js";
import { getExistingProductImage } from "./productImage.js";
import { getSalesLineId } from "../util/orderUtil.js";
//import moment from "moment";

export const SET_PRODUCT_ORDER_VIEW = "SET_PRODUCT_ORDER_VIEW";
export const SET_ACTIVE_ORDER = "SET_ACTIVE_ORDER";
export const MERGE_ACTIVE_ORDER = "MERGE_ACTIVE_ORDER";
export const ADD_TO_UNCONFIRMED_ORDER = "ADD_TO_UNCONFIRMED_ORDER";
export const REMOVE_FROM_UNCONFIRMED_ORDER = "REMOVE_FROM_UNCONFIRMED_ORDER";
export const UPDATE_UNCONFIRMED_ORDER_LINE = "UPDATE_UNCONFIRMED_ORDER_LINE";
export const SET_UNCONFIRMED_ORDER_LINE_INFO = "SET_UNCONFIRMED_ORDER_LINE_INFO";
export const SET_UNCONFIRMED_ORDER_LINE_LOADING = "SET_UNCONFIRMED_ORDER_LINE_LOADING";
export const SET_ACTIVE_ORDERED_IMAGE_URL = "SET_ACTIVE_ORDERED_IMAGE_URL";
export const SET_ACTIVE_UNCONFIRMEDORDER_IMAGE_URL = "SET_ACTIVE_UNCONFIRMEDORDER_IMAGE_URL";
export const SET_ACTIVE_ORDER_LOADING = "SET_ACTIVE_ORDER_LOADING";
export const SET_ACTIVE_ORDER_SUBMITTING = "SET_ACTIVE_ORDER_SUBMITTING";
export const UPDATE_UNCONFIRMED_LINE = "UPDATE_UNCONFIRMED_LINE";
export const SET_ORDER_FEE_LIMITS = "SET_ORDER_FEE_LIMITS";
export const SET_ORDER_VOLUME_DISCOUNTS = "SET_ORDER_VOLUME_DISCOUNTS";
export const SET_FRESHFOOD_TEMPLATE = "SET_FRESHFOOD_TEMPLATE";
export const SET_FRESHFOOD_TEMPLATE_UPDATED = "SET_FRESHFOOD_TEMPLATE_UPDATED";

const setOrderView = (value) => ({
    type: SET_PRODUCT_ORDER_VIEW,
    value
});

/**
 * Sets what view should be shown under /order/products
 * @param {string} newView 
 * @returns {func}
 */
export function setOrderProductView(newView){
    return async (dispatch) => {
        try {
            dispatch(setOrderView(newView));
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Gets the order fee limits
 * @returns {function}
 */
export function getOrderFeeLimits(){
    return async (dispatch) => {
        try {
            const payload = await dispatch(getApi("Order/OrderFeeLimitsQuery"));
            if( payload.message==="OK" && payload.payload) {
                dispatch({
                    type: SET_ORDER_FEE_LIMITS,
                    orderFeeLimits: payload.payload,
                });
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Innlastingsgebyrgrenser mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Gets the order fee limits
 * @returns {function}
 */
export function getOrderVolumeDiscounts(){
    return async (dispatch) => {
        try {
            const payload = await dispatch(getApi("Order/OrderVolumeDiscountQuery"));
            if( payload.message==="OK" && payload.payload) {
                dispatch({
                    type: SET_ORDER_VOLUME_DISCOUNTS,
                    orderVolumeDiscounts: payload.payload,
                });
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Innlastingsgebyrgrenser mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Sets what order we are working on
 * @param {number} shipmentId 
 * @param {string} distributionRouteId 
 * @param {string} deliveryDate 
 * @param {boolean} waitForReservation
 * @returns {func}
 */
export function setActiveOrder(shipmentId, distributionRouteId, deliveryDate, waitForReservation = false){
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_ACTIVE_ORDER_LOADING,
                loading: true,
            });

            const data = {
                shipmentId,
                distributionRouteId,
                deliveryDate,
                waitForReservation,
            };
            
            const payload = await dispatch(getApi("Order/DeliveryQuery", data));//TODO: Order/DeliveryQuery always returns "OK" even when failing
            if( payload.message==="OK" && payload.payload) {
                const activeOrder = payload.payload;

                if( activeOrder.orderLines ){
                    //insert existing images
                    for(let i=0; i<activeOrder.orderLines.length; i++){
                        activeOrder.orderLines[i].product.imageUrl = getExistingProductImage(activeOrder.orderLines[i].product.productId);
                    }
                }
                if( activeOrder.unConfirmedOrderLines ){
                    //insert existing images
                    for(let i=0; i<activeOrder.unConfirmedOrderLines.length; i++){
                        activeOrder.unConfirmedOrderLines[i].product.imageUrl = getExistingProductImage(activeOrder.unConfirmedOrderLines[i].product.productId);
                    }
                }
                //store data
                dispatch({
                    type: SET_ACTIVE_ORDER,
                    activeOrder,
                });
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Kunne ikke få leveringsordre", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: SET_ACTIVE_ORDER_LOADING,
                loading: false,
            });
        }
    };
}

/**
 * Sets that there is no loading being executed
 * @returns {func}
 */
export function setNoOrderAvailable(){
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_ACTIVE_ORDER_LOADING,
                loading: false,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}
/**
 * adds or remove products to the temporary order. This function also makes sure that only a single api call is being used at the same time
 * @param {object} activeOrder
 * @param {object} product 
 * @param {number} qty
 * @param {number} salesLineId
 * @param {boolean} ignoreLoading //Should not be used, It is used internally as a flag
 * @returns {func}
 */ 
export function addRemoveProductToTemporaryOrder(activeOrder, product, qty, salesLineId, ignoreLoading = false){
    return async (dispatch, getState) => {
        try {
            const shipmentId = activeOrder.shipmentId;
            const distributionRouteId = activeOrder.distributionRouteId;
            const deliveryDate = activeOrder.deliveryDate;
            const salesOrderId = activeOrder.orderLines && activeOrder.orderLines.length>0 && activeOrder.orderLines[0].salesOrderId || 0;
            const data = {
                distributionRouteId: distributionRouteId,
                shipmentId: shipmentId,
                salesOrderId: salesOrderId,
                orderLines: [{
                    productId: product.productId,
                    qty: qty,
                    salesLineId: salesLineId ? salesLineId: getSalesLineId(activeOrder, product.productId, true),
                }],
            };
            if( shipmentId==null ){
                dispatch(pushSystemMessage("Kan ikke legge til produkt til ingen eksisterende ordre", messageType.error));
                return;
            }
            const line = getState().order.active.unConfirmedOrderLines && getState().order.active.unConfirmedOrderLines.find( (item) => item.productId===product.productId);
            const getQtyDiff = () => {
                const newLine = getState().order.active.unConfirmedOrderLines && getState().order.active.unConfirmedOrderLines.find( (item) => item.productId===product.productId);
                //check if something has changed during the api call
                return newLine.orderedQty-qty;
            };
            const canBeRemoved = () => {
                const newLine = getState().order.active.unConfirmedOrderLines && getState().order.active.unConfirmedOrderLines.find( (item) => item.productId===product.productId);
                //if it is in ordered it cant be removed visually (0 is a legal number, as that will remove the line on commit)
                const isOrdered = getState().order.active.orderLines && getState().order.active.orderLines.find( (item) => item.productId===product.productId);
                //check if something has changed during the api call
                return isOrdered==null && newLine.orderedQty-qty===0 ;
            };

            //Make sure that we are not trying to edit locked product
            if( line && (line.isLocked || line.isKitMember) ){
                return;
            }
            //if minimum to order of the product is set
            if( line && line.mustOrderAtLeastOne && qty===0){
                data.orderLines[0].qty = 1;
                qty = 1;
            }

            try {
                //if the product is waiting for a response from the server, then we just update the local qty
                if(line && line.loading===true && ignoreLoading===false){
                    dispatch({
                        type: UPDATE_UNCONFIRMED_ORDER_LINE,
                        productId: product.productId,
                        line: {
                            ...line,
                            orderedQty: qty,
                        }
                    });
                }
                //If not waiting
                else {
                    //If product should be REMOVED
                    if( line && qty===0 ){
                        dispatch({
                            type: UPDATE_UNCONFIRMED_ORDER_LINE,
                            productId: product.productId,
                            line: {
                                ...line,
                                loading: true,//Set flag to indicate that the product is beeing worked on
                                orderedQty: qty,
                            }
                        });
                        const payload = await dispatch(postApi("Order/AddRemoveLinesToTemporaryOrder", data));
                        if( payload.payload) {
                            const activeOrder = payload.payload;
                            dispatch({
                                type: MERGE_ACTIVE_ORDER,
                                activeOrderChange: {
                                    sumExVat: activeOrder.sumExVat,
                                    baseAmountOrderFee: activeOrder.baseAmountOrderFee,
                                    orderFee: activeOrder.orderFee,
                                    nextOrderFeeLevel: activeOrder.nextOrderFeeLevel,
                                }
                            });
                            //Check if qty has changed
                            const qtyDiff = getQtyDiff();
                            if(qtyDiff===0){
                                //no diff delete the row, if possible
                                if( canBeRemoved() ){
                                    dispatch({
                                        type: REMOVE_FROM_UNCONFIRMED_ORDER,
                                        productId: product.productId,
                                    });
                                } else {
                                    //if not possible to remove, then the loading is done
                                    dispatch({
                                        type: SET_UNCONFIRMED_ORDER_LINE_LOADING,
                                        productId: product.productId,
                                        loading: false,
                                    });
                                }
                            } else {
                                //products have been added
                                await dispatch( addRemoveProductToTemporaryOrder(getState().order.active, product, qty+qtyDiff, salesLineId, true));
                            }
                        }
                    }
                    //If it will be ADDED (Done to get specific data about the product like isKitMember, isLocked, mustOrderAtLeastOne)
                    else if( line==null ){
                        dispatch({
                            type: ADD_TO_UNCONFIRMED_ORDER,
                            line: {
                                loading: true, //Set flag to indicate that the product is beeing worked on
                                productId: product.productId,
                                orderedQty: qty,
                                product: {
                                    ...product,
                                    imageUrl: getExistingProductImage(product.productId),
                                }
                            },
                        });
                        const payload = await dispatch(postApi("Order/AddRemoveLinesToTemporaryOrder", data));
                        let success = false;
                        if( payload.payload) {
                            const activeOrder = payload.payload;
        
                            //loop all unConfirmedOrderLines and add only the new product
                            if( activeOrder.unConfirmedOrderLines ){
                                for(let i=0; i<activeOrder.unConfirmedOrderLines.length; i++){
                                    if( activeOrder.unConfirmedOrderLines[i].product.productId === product.productId){
                                        activeOrder.unConfirmedOrderLines[i].product.imageUrl = getExistingProductImage(product.productId);
                                        //store information isKitMember, isLocked, mustOrderAtLeastOne, and more (qty may have changed by other and should not be touched)
                                        dispatch({
                                            type: SET_UNCONFIRMED_ORDER_LINE_INFO,
                                            productId: product.productId,
                                            line: {
                                                ...activeOrder.unConfirmedOrderLines[i],
                                            },
                                        });
                                        success = true;

                                        //Check if qty has changed, and fixit
                                        const qtyDiff = getQtyDiff();
                                        if(qtyDiff!==0){
                                            await dispatch( addRemoveProductToTemporaryOrder(getState().order.active, product, qty+qtyDiff, salesLineId, true) );
                                        } else {
                                            //no diff
                                            dispatch({
                                                type: SET_UNCONFIRMED_ORDER_LINE_LOADING,
                                                productId: product.productId,
                                                loading: false,
                                            });
                                        }

                                    }
                                }
                            }

                            dispatch({
                                type: MERGE_ACTIVE_ORDER,
                                activeOrderChange: {
                                    sumExVat: activeOrder.sumExVat,
                                    baseAmountOrderFee: activeOrder.baseAmountOrderFee,
                                    orderFee: activeOrder.orderFee,
                                    nextOrderFeeLevel: activeOrder.nextOrderFeeLevel,
                                }
                            });
                        }
                        if(!success){
                            dispatch( pushSystemMessage("Å legge varen til ordren mislyktes") );
                            throw "";
                        }
                    }
                    //if UPDATE
                    else {
                        //store the new qty directly
                        dispatch({
                            type: UPDATE_UNCONFIRMED_ORDER_LINE,
                            productId: product.productId,
                            line: {
                                ...line,
                                loading: true,
                                orderedQty: qty,
                            }
                        });
                        const payload = await dispatch(postApi("Order/AddRemoveLinesToTemporaryOrder", data));
                        if( payload.payload) {
                            const activeOrder = payload.payload;
                            dispatch({
                                type: MERGE_ACTIVE_ORDER,
                                activeOrderChange: {
                                    sumExVat: activeOrder.sumExVat,
                                    baseAmountOrderFee: activeOrder.baseAmountOrderFee,
                                    orderFee: activeOrder.orderFee,
                                    nextOrderFeeLevel: activeOrder.nextOrderFeeLevel,
                                }
                            });

                            //Check if qty has changed, and fixit
                            const qtyDiff = getQtyDiff();
                            if(qtyDiff!==0){
                                await dispatch( addRemoveProductToTemporaryOrder(getState().order.active, product, qty+qtyDiff, salesLineId, true) );
                            } else {
                                dispatch({
                                    type: SET_UNCONFIRMED_ORDER_LINE_LOADING,
                                    productId: product.productId,
                                    loading: false,
                                });
                            }
                        }
                    }
                
                    if (ignoreLoading===false) {
                        await dispatch( getNextDelivery());
                        await dispatch( setActiveOrder(shipmentId, distributionRouteId, deliveryDate) );
                    }
                }
            } catch (error) {
                //Something failed, reload the entire active order
                dispatch(pushSystemMessage(error && error.message || "Kunne ikke oppdatere handlekurven", messageType.error));
                
                const data = {
                    shipmentId,
                    distributionRouteId,
                    deliveryDate,
                };
                //Set loading to true, to stop the user from editing the broken cart
                dispatch({
                    type: SET_ACTIVE_ORDER_LOADING,
                    loading: true,
                });
                const payload = await dispatch(getApi("Order/DeliveryQuery", data));
                if( payload.message==="OK" && payload.payload) {
                    const activeOrder = payload.payload;

                    if( activeOrder.orderLines ){
                        //insert existing images
                        for(let i=0; i<activeOrder.orderLines.length; i++){
                            activeOrder.orderLines[i].product.imageUrl = getExistingProductImage(activeOrder.orderLines[i].product.productId);
                        }
                    }
                    if( activeOrder.unConfirmedOrderLines ){
                        //insert existing images
                        for(let i=0; i<activeOrder.unConfirmedOrderLines.length; i++){
                            activeOrder.unConfirmedOrderLines[i].product.imageUrl = getExistingProductImage(activeOrder.unConfirmedOrderLines[i].product.productId);
                        }
                    }
                    //store data
                    dispatch({
                        type: SET_ACTIVE_ORDER,
                        activeOrder,
                    });
                }
            }

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Kunne ikke oppdatere handlekurven", messageType.error));
            Logger.error(error);
        }
    };
}
/**
 * adds or remove products to the temporary order
 * @param {number} shipmentId 
 * @param {number} distributionRouteId 
 * @param {string} deliveryDate 
 * @param {array} prdLine 
 * @returns {func}
 */ 
export function addRemoveLinesToTemporaryOrder(shipmentId, distributionRouteId, deliveryDate, prdLine){
    return async (dispatch, getState) => {
        try {
            //Load in into state.order.active
            await dispatch(setActiveOrder(shipmentId, distributionRouteId, deliveryDate) );
            const data = {
                distributionRouteId: distributionRouteId,
                shipmentId: shipmentId,
                salesOrderId: getState().order.active.orderId,
                orderLines: prdLine,
            };
            //send in change
            const payload = await dispatch(postApi("Order/AddRemoveLinesToTemporaryOrder", data));
            if( payload.message==="OK") {
                //get updated order                
                await dispatch( setActiveOrder(shipmentId, distributionRouteId, deliveryDate) );
                await dispatch( getNextDelivery());
            }

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Endring av ordre mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Moves all unconfirmed lines to the next deliveryDate
 * @param {bool} deleteOrder 
 * @returns {func}
 */
export function moveUnconfirmedLinesToNextOrder(deleteOrder){
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_ACTIVE_ORDER_LOADING,
                loading: true,
            });

            await dispatch(postApi("Order/MoveUnconfirmedOrderToNextDelivery", { 
                onlyDeleteOrder: deleteOrder,
            }));

            await dispatch( getNextDelivery());            
        }
        catch(error) {
            Logger.log(error);
        } finally {
            dispatch({
                type: SET_ACTIVE_ORDER_LOADING,
                loading: false,
            });
        }
    };
}

/**
 * Submits a given order
 * @param {object} activeOrder 
 * @returns {func}
 */
export function submitOrder(activeOrder){
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_ACTIVE_ORDER_SUBMITTING,
                submitting: true,
            });
            const data = {
                routeId: activeOrder.distributionRouteId,
                shipmentId: activeOrder.shipmentId,
            };
            const payload = await dispatch(postApi("Order/SubmitOrder", data));
            if( payload.message==="OK") {
                //get updated order
                await dispatch( setActiveOrder(activeOrder.shipmentId, activeOrder.distributionRouteId, activeOrder.deliveryDate) );
                await dispatch( getNextDelivery());
                await dispatch( getDeliveries());
            }

            if( payload.payload) {
                //get updated order
                dispatch(pushSystemMessage(payload.payload, messageType.message));
            }
  

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Sendingsordren mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: SET_ACTIVE_ORDER_SUBMITTING,
                submitting: false,
            });
        }
    };
}

/**
 * Downloads a pdf
 * @param {object} delivery
 * @param {string} token
 * @returns {func}
 */
export function showShoppingCartPdf(delivery, token){
    return async (dispatch) => {
        try {
            const blob = await getBlob("Order/GenerateShoppingCartPdf", delivery, token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `${delivery.deliveryDate}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        }
    };
}

/**
 * Gets fresh food templates
 * @returns {func}
 */
export function getFreshFoodTemplates(){
    return async (dispatch) => {
        try {
            const payload = await dispatch( getApi("Order/FreshFoodTemplateQuery"));

            if( payload)
            {
                const products = payload.payload.products;

                for(let i=0; i<products.length; i++){
                    
                    // Also set price in product and image property in freshFoodProducts array
                    const imageUrl = getExistingProductImage(products[i].productId);
                    products[i].imageUrl = imageUrl;
                   
                    const productData = payload.payload.freshFoodProducts.find(p => p.productId === products[i].productId);    
                    products[i].price = productData ? productData.price : null;

                    if (productData) {
                        productData.imageUrl = imageUrl;
                    }
                }

                dispatch({
                    type: SET_FRESHFOOD_TEMPLATE,
                    templateData: payload.payload,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}


/**
 * Updates the fresh food template
 * @param {object} change
 * @param {object} product
 * @param {number} hubId
 * @returns {func}
 */
export function updateTemplateQty(change, product, hubId){
    return async (dispatch, getState) => {
        try {

            var keys = Object.keys(change);
 
            const newProduct = {... product};
            newProduct[keys[0]] = Number(change[keys[0]]);

            const data = {
                changedDto : {
                    customerId:  getState().authentication.signedInAs,
                    hubId: hubId,
                    products: [newProduct],
                }               
            };

            const payload = await dispatch(postApi("Order/UpdateTemplateQty", data));
            if( payload.message==="OK") {
                //get updated order
                //await dispatch( getDeliveries());
                dispatch({
                    type: SET_FRESHFOOD_TEMPLATE_UPDATED,
                    product: newProduct,
                });
            }
        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Feil ved oppdatering", messageType.error) );
            Logger.error(error);
        }
    };
}